'use client';

import { Suspense } from 'react';

import { LoadingOverlay } from '@/components/Load/loading-overlay';

import { SignUpForm } from './components/SignUpForm';

export default function SignUpPage() {
  return (
    <Suspense fallback={<LoadingOverlay isLoading={true} />}>
      <SignUpForm />
    </Suspense>
  );
}
